import { Switch } from "@mantine/core";
import { IconArchive } from "@tabler/icons-react";
import { useStatusStore } from "@/utils/stores/useStatusStore";
import "./ArchiveToggle.scss";

const ArchiveToggle = () => {
  const { showArchivedClients, setShowArchivedClients } = useStatusStore();

  return (
    <Switch
      label="Show Archived Clients"
      description="Include archived clients in the list"
      checked={showArchivedClients}
      onChange={(event) => setShowArchivedClients(event.currentTarget.checked)}
      thumbIcon={
        showArchivedClients ? (
          <IconArchive size={12} stroke={2.5} />
        ) : (
          <IconArchive size={12} stroke={2.5} />
        )
      }
      size="md"
      data-testid="archive-toggle"
    />
  );
};

export default ArchiveToggle;
